import { render, staticRenderFns } from "./WebKanban.vue?vue&type=template&id=744e4335&scoped=true&"
import script from "./WebKanban.vue?vue&type=script&lang=js&"
export * from "./WebKanban.vue?vue&type=script&lang=js&"
import style0 from "./WebKanban.vue?vue&type=style&index=0&id=744e4335&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744e4335",
  null
  
)

export default component.exports